import { InternImageWallItem } from '../intern/image-wall-item';
import { ContentIntro } from './intro';

/**
 * Model definition for ImageWall
 */
export interface ContentImageWall {
  __component: 'content.image-wall';
  id: string;
  intro?: ContentIntro;
  items: InternImageWallItem[];
}

export function isContentImageWall(obj: { __component?: string }): obj is ContentImageWall {
  return obj.__component === 'content.image-wall';
}
